import React from 'react';
import { ExternalLink, RefreshCw } from 'lucide-react';

interface JiraBadgeProps {
  issueKey: string;
  instanceUrl?: string;
  onSync?: () => void;
  syncing?: boolean;
  className?: string;
}

const JiraBadge: React.FC<JiraBadgeProps> = ({
  issueKey,
  instanceUrl,
  onSync,
  syncing = false,
  className = ''
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (instanceUrl) {
      e.stopPropagation();
      window.open(`${instanceUrl}/browse/${issueKey}`, '_blank');
    }
  };

  return (
    <div className={`inline-flex items-center space-x-1 ${className}`}>
      <button
        onClick={handleClick}
        className="inline-flex items-center px-2 py-1 rounded bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors text-xs font-medium"
        title={`View ${issueKey} in Jira`}
      >
        <svg className="h-3 w-3 mr-1" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.571 11.513H0a5.218 5.218 0 0 0 5.232 5.215h2.13v2.057A5.215 5.215 0 0 0 12.575 24V12.487a.974.974 0 0 0-.974-.974h-.03zm5.723-5.756H5.736a5.215 5.215 0 0 0 5.215 5.214h2.129v2.058a5.218 5.218 0 0 0 5.215 5.214V6.731a.974.974 0 0 0-.974-.974h-.027zM23.013 0H11.455a5.215 5.215 0 0 0 5.215 5.215h2.129v2.057A5.215 5.215 0 0 0 24 12.487V.974A.974.974 0 0 0 23.013 0z"/>
        </svg>
        <span>{issueKey}</span>
        {instanceUrl && (
          <ExternalLink className="h-3 w-3 ml-1" />
        )}
      </button>

      {onSync && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onSync();
          }}
          disabled={syncing}
          className="p-1 text-gray-400 hover:text-blue-600 disabled:opacity-50"
          title="Sync with Jira"
        >
          <RefreshCw className={`h-3 w-3 ${syncing ? 'animate-spin' : ''}`} />
        </button>
      )}
    </div>
  );
};

export default JiraBadge;
